import * as React from "react";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { FirmInstructionHistoryCollectionModel } from "../../../../Wrap/Models/Models/Company/FirmInstructionHistoryCollectionModel";
import { NetworkAction } from "../Actions/NetworkAction";
import { NetworkInstructionStore, NetworkStore, NetworkWizardStore } from "../Stores/Variable";
import { NetworkFilter } from "./NetworkFilter";
import { Dictionary } from "../../../../react-core/Helpers/CommonHelper";
import { InstructionStatus } from "../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { NetworkTable } from "./NetworkTable";
import { checkPermission } from "../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";

export type INetworkSubmittedProps = React.Props<NetworkSubmitted>;

interface INetworkSubmittedState {
    tableData: FirmInstructionHistoryCollectionModel;
    isLoading?: boolean;
    currentPage: number;
    filter: any;
}

export class NetworkSubmitted extends FormComponent<INetworkSubmittedProps, INetworkSubmittedState> {
    constructor(props: INetworkSubmittedProps) {
        super(props);
        this.state = {
            tableData: null,
            isLoading: false,
            currentPage: 1,
            filter: {
                Statuses: [InstructionStatus.Submitted, InstructionStatus.Complete],
                NetworkProcessType: 0,
                NetworkType: 0,
                NetworkName: "",
                TradingReference: "",
                CreateUserId: null,
                StartedFromDate: null,
                StartedToDate: null,
                UpdatedFromDate: null,
                UpdatedToDate: null,
                Count: 10,
            },
        };
        this.subscribeToStore(NetworkInstructionStore, () => this.onNetworkStoreChange());
    }

    public render(): JSX.Element {
        if (!checkPermission(UserClaim.AdviserPortalNetworkAndFirmReadWrite)) {return null;}
        return (
            <>
                {this.renderFilter()}
                {this.renderTable()}
            </>
        );
    }

    private renderTable(): JSX.Element {
        const { tableData, currentPage, filter, isLoading } = this.state;
        return (
            <NetworkTable
                tableData={tableData}
                currentPage={currentPage}
                pageSize={filter.Count}
                isLoading={isLoading}
                handlePageChange={this.handlePageChange}
                inprogress={false}
            />
        );
    }

    private renderFilter(): JSX.Element {
        const { filter } = this.state;
        return <NetworkFilter filter={filter} handleFilterChange={this.handleFilterChange} onSearch={this.onSearch} />;
    }

    handleFilterChange = (changes: Dictionary[]) => {
        const updatedfilter = this.state.filter;
        for (const key in changes) {
            updatedfilter[key] = changes[key];
        }   
        this.setState({ filter: updatedfilter });
    };

    handlePageChange = (pageIndex: number) => {
        this.setState({ currentPage: pageIndex });
        this.getData(pageIndex);
    };

    private onNetworkStoreChange() {
        const data = NetworkInstructionStore.getData();
        this.setState({ tableData: data, isLoading: false });
    }

    onSearch = () => {
        this.setState({ currentPage: 1 });
        this.getData(1);
    };

    private getData(pageIndex: number): void {
        const query = this.getQuery(pageIndex);
        this.setState({ isLoading: true });
        NetworkAction.getNetworkList(query);
    }

    private getQuery(pageIndex: number): any {
        const { filter } = this.state;
        const start = (pageIndex - 1) * filter.Count + 1;
        const query = JSON.parse(JSON.stringify(filter));
        query.Start = start;
        query.Count = start + 10;
        return query;
    }
}
